// Report status enum
export enum ReportStatus {
  Pending = 'pending',
  Missed = 'missed',
  Completed = 'completed',
  Due = 'due',
  Submitted = 'submitted',
  Late = 'late',
}

// Base report interface
export interface Report {
  id: string;
  type: 'petParent' | 'adoption';
  dueDate: string; // ISO format from backend, parse in component
  status: ReportStatus;
  timeframeStart?: string; // ISO format for the start of the report timeframe
  isWarning?: boolean;
}
